import React from "react"
import SignUpForm from "./SignUpForm"
import { Container } from "reactstrap"
import { NavLink } from "react-router-dom"
import { Trans } from "@lingui/react"
import { useSelector } from "react-redux"

export default function SignUpPage() {
  const { loadingToggleState } = useSelector(({ loadingToggleState }) => ({
    loadingToggleState,
  }))

  const loadingStyle = {
    fontFamily: "Fira Sans",
    fontSize: "18px",
  }
  return (
    <Container>
      <SignUpForm />
      {!loadingToggleState && (
        <Container style={{ textAlign: "center" }}>
          <span style={loadingStyle}>
            <Trans id="already.have.account" />
          </span>
          <NavLink to={{ pathname: `/` }}>
            {" "}
            <b>
              <u>
                <Trans id="login" />
              </u>
            </b>
          </NavLink>
        </Container>
      )}
    </Container>
  )
}
